import LoginSso from "./LoginSso";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { tryGoogleAuthorisedUserLogin } from "services/redux/auth/login/action";

const mapStateToProps = (state) => ({
  otp: state.loginOtp.otp,
  login_data: state.loginOtp.login_data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tryGoogleAuthorisedUserLogin,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoginSso);
